(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name PostsController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('PostsController', PostsController);
    PostsController.$inject = ["PostsService","$timeout"];

    function PostsController(PostsService,$timeout){
  
        var vm = this;
        vm.loading = false;
        vm.page = 1;
        vm.maxPages = 0;
        vm.offset = 3;
        vm.totalItems = 0;
        vm.cat_posts = "";
        vm.filtros = {};
        vm.filtros.page = 0;

        vm.getposts = function(noreset){
        
            if (!noreset) {
                vm.posts =[];
                vm.filtros.page = 0;
            }
             vm.loading =true;
             vm.error = false;
            PostsService.getPost(vm).then(function(data){
                vm.posts = vm.posts.concat(data.posts);
                vm.maxPages = (data.maxPages)-1;
                vm.totalItems = data.items;
                vm.cat_posts = data.cat_posts;
                 vm.loading = false;
                 if ( vm.posts.length === 0) {
                    vm.error = true;
                }

            });
               
              
        }

        vm.filtrosbutton = function(id){
            vm.filtros.cat_noticias = id;
        };

        vm.next = function(){
            vm.page++;
            vm.getposts();
        };

        vm.prev = function(){
            vm.page--;
            vm.getposts();
        };

    }

})();